module.exports = __webpack_public_path__ + "static/logo_SEW_x192_wht-a9dd8f80412ea700eae6de95eb8fad08.png";